import React,{useState,useContext} from "react";
import axios from "axios";
import { CHECK_USER_URL,LOGIN_URL,USER_UPDATE_URL,USER_FORGOT_PASSWORD_URL,USER_NEW_PASSWORD_URL,GET_USER_PROFILE,PUBLIC_PROFILE_URL } from "../Utils/URLs";
import { useNavigate } from "react-router-dom";
import {toast} from "react-toastify"
import { UserContext } from "./UserContext";
const AuthState = ()=>{
    const [formBusy,setFormBusy] = useState(false)
    const [message,setMessage] = useState("")
    const [response,setResponse] = useState("")
   
    const {LoginUser,setUser} = useContext(UserContext)
    const [publicData,setPublicData] = useState({})
const navigate = useNavigate()
const token = localStorage.getItem("token")

const CheckUser = async(data)=>{
    try{
        setFormBusy(true)
        await axios.post(CHECK_USER_URL,data).then((res)=>{
            setMessage(res.data)
        })
        setFormBusy(false)
    }catch(error){
        console.log(error)
        setFormBusy(false)
    }
}


const Login = async (data)=>{
    try {
        setFormBusy(true)
        await axios.post(LOGIN_URL,data).then((res)=>{
            if(res.data.type==="success"){
                console.log(res.data)
                LoginUser(res.data.response)
                localStorage.setItem("token",res.data.response.token)
                localStorage.setItem("role",res.data.response.role)
                if(res.data.response.isSubmit==="0"){
                    navigate("/driver_forms/submit")
                }else{

                    navigate("/driver_forms/profile")
                }
            }
        })
        setFormBusy(false)
    } catch (error) {
    console.log(error)
    setFormBusy(false)
    if(error.response.data.type==="error"){
        console.log(error.response.data)
        toast.error(error.response.data.message,{
            position:"top-right"
        })
    }
    }
}
const UpdateProfile = async (data)=>{
    try {
        setFormBusy(true)
        await axios.post(USER_UPDATE_URL,data,{
            headers:{
                Authorization:`Bearer ${token}`
            }
        }).then((res)=>{
            if(res.data.type==="success"){
                toast.success(res.data.message,{
                    position:"top-right"
                })
                console.log("in state......",res.data)
                setResponse(res.data.response)
                setUser(res.data.response)
                localStorage.setItem("user",JSON.stringify(res.data.response))
            }
           
        })
        setFormBusy(false)
    } catch (error) {
    console.log(error)
    setFormBusy(false)
    if(error.response.data.type==="error"){
        console.log(error.response.data)
        toast.error(error.response.data.message,{
            position:"top-right"
        })
    }
    }
}

const UserForgotPassword = async (email) =>{
    try{
        setFormBusy(true)
        await axios.post(USER_FORGOT_PASSWORD_URL,email).then((res)=>{
            if(res.data.type==="error"){
                toast.error(res.data.message,{
                    position:"top-right"
                })
            }else{
                toast.success(res.data.message,{
                    position:"top-right"
                })
            }
        })
        setFormBusy(false)
    }catch(error){
        console.log(error)
    }
}

const NewPassword = async (token,password) =>{
    try{
        setFormBusy(true)
        await axios.post(USER_NEW_PASSWORD_URL,password,{
            headers:{
                Authorization:`Bearer ${token}`
            }
        }).then((res)=>{
           
            if(res.data.msg==="error"){
              return  toast.error(res.data.response,{
                    position:"top-right"
                })
            }
             
           if(res.data.type==="success") {
                toast.success(res.data.message,{
                    position:"top-right"
                })
                navigate("/driver_forms/login")
            }
        })
        setFormBusy(false)
    }catch(error){
        console.log(error)
        setFormBusy(false)
        if(error.response.data.msg==="token_error"){
            return toast.error(error.response.data.response,{
                 position:"top-right"
             })
         }
         
    }
}

const GetUserProfile = async () =>{
    try{
       
        await axios.get(GET_USER_PROFILE,{
            headers:{
                Authorization:`Bearer ${token}`
            }
        }).then((res)=>{
            setUser(res.data.response)
            localStorage.setItem("user",JSON.stringify(res.data.response))
        })
       
    }catch(error){
        console.log(error)
    }
}

const GetPublicProfile = async (data) =>{
    try{
        if (!data) return;
        setFormBusy(true)
        const res = await axios.post(PUBLIC_PROFILE_URL, { data: String(data).trim() })
        if (res.data && res.data.type === "success" && res.data.response && res.data.response[0]) {
            setPublicData(res.data.response[0])
        } else {
            setPublicData({})
        }
    }catch(error){
        console.log("GetPublicProfile error:", error?.response?.data || error?.message)
        setPublicData({})
    }finally{
        setFormBusy(false)
    }
}


return{
    CheckUser,
    formBusy,
    message,
    Login,
    UpdateProfile,
    response,
    UserForgotPassword,
    NewPassword,
    GetUserProfile,
    GetPublicProfile,
    publicData
   
}
}

export default AuthState